export default "__VITE_ASSET__Ba9xWL9v__"